namespace Matrix.Dashboards {
    export interface WidgetCatalogForm {
        WidgetCode: Serenity.StringEditor;
        Name: Serenity.StringEditor;
        WidgetType: Serenity.LookupEditor;
        Permission: Serenity.StringEditor;
        Version: StaticTextBlock;
        CreatedBy: StaticTextBlock;
        CreatedWhen: ReadOnlyDateTime;
        UpdatedBy: StaticTextBlock;
        UpdatedWhen: ReadOnlyDateTime;
    }

    export class WidgetCatalogForm extends Serenity.PrefixedContext {
        static formKey = 'Dashboards.WidgetCatalog';
        private static init: boolean;

        constructor(prefix: string) {
            super(prefix);

            if (!WidgetCatalogForm.init)  {
                WidgetCatalogForm.init = true;

                var s = Serenity;
                var w0 = s.StringEditor;
                var w1 = s.LookupEditor;
                var w2 = StaticTextBlock;
                var w3 = ReadOnlyDateTime;

                Q.initFormType(WidgetCatalogForm, [
                    'WidgetCode', w0,
                    'Name', w0,
                    'WidgetType', w1,
                    'Permission', w0,
                    'Version', w2,
                    'CreatedBy', w2,
                    'CreatedWhen', w3,
                    'UpdatedBy', w2,
                    'UpdatedWhen', w3
                ]);
            }
        }
    }
}
